/* IVYN Theme JavaScript */

// ── Sticky header
const siteHeader = document.getElementById('site-header');
if (siteHeader) {
  window.addEventListener('scroll', () => {
    siteHeader.classList.toggle('scrolled', window.scrollY > 8);
  }, { passive: true });
}

// ── Mobile menu
const mobNav = document.getElementById('mob-nav');
const hamBtn = document.getElementById('ham-btn');
const mobClose = document.getElementById('mob-close');
document.querySelectorAll('.mob-head').forEach((btn) => {
  btn.addEventListener('click', () => {
    const section = btn.closest('.mob-section');
    if (!section) return;
    const isOpen = !section.classList.contains('open');
    section.classList.toggle('open', isOpen);
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    const symbol = btn.querySelector('.mob-head-symbol');
    if (symbol) symbol.textContent = isOpen ? '-' : '+';
  });
});
if (hamBtn && mobNav) {
  hamBtn.addEventListener('click', () => {
    mobNav.classList.add('open');
    document.body.classList.add('mob-nav-open');
    hamBtn.setAttribute('aria-expanded', 'true');
  });
}
if (mobClose && mobNav) {
  mobClose.addEventListener('click', () => {
    mobNav.classList.remove('open');
    document.body.classList.remove('mob-nav-open');
    if (hamBtn) hamBtn.setAttribute('aria-expanded', 'false');
  });
}

// ── Hero slideshow
(function () {
  const slides = [...document.querySelectorAll('.slide')];
  const dots   = [...document.querySelectorAll('.dot')];
  if (!slides.length) return;
  let cur = 0, tmr;

  function goTo(n) {
    slides[cur].classList.remove('on');
    if (dots[cur]) dots[cur].classList.remove('on');
    cur = (n + slides.length) % slides.length;
    slides[cur].classList.add('on');
    if (dots[cur]) dots[cur].classList.add('on');
  }
  function resetTimer() {
    clearInterval(tmr);
    tmr = setInterval(() => goTo(cur + 1), 5800);
  }

  const nextBtn = document.getElementById('hero-next');
  const prevBtn = document.getElementById('hero-prev');
  if (nextBtn) nextBtn.addEventListener('click', () => { goTo(cur + 1); resetTimer(); });
  if (prevBtn) prevBtn.addEventListener('click', () => { goTo(cur - 1); resetTimer(); });
  dots.forEach(d => d.addEventListener('click', () => { goTo(+d.dataset.to); resetTimer(); }));

  // Swipe
  let tx = 0;
  const heroEl = document.getElementById('hero-section');
  if (heroEl) {
    heroEl.addEventListener('touchstart', e => { tx = e.touches[0].clientX; }, { passive: true });
    heroEl.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 50) { dx < 0 ? goTo(cur + 1) : goTo(cur - 1); resetTimer(); }
    });
  }
  resetTimer();
})();
// ── Product page gallery (legacy) — PATCHED 19 Jul 2026
// Fix 1: exit when the modern PDP slider (#gslider-track in product-main.liquid) owns the
//        gallery — double-binding crashed on every thumbnail tap and desynced image classes.
// Fix 2: NaN/bounds guards — markup uses data-index, so +t.dataset.idx was always NaN.
(function () {
  if (document.getElementById('gslider-track')) return; /* modern PDP gallery controller present */
  const imgEls   = document.querySelectorAll('.gallery-main img');
  const thumbEls = document.querySelectorAll('.thumb');
  if (!imgEls.length) return;
  let currentImg = 0;

  function showImg(idx) {
    idx = parseInt(idx, 10);
    if (!Number.isFinite(idx)) idx = 0;
    const prevEl = imgEls[currentImg];
    if (prevEl) prevEl.classList.replace('active', 'hidden');
    if (thumbEls[currentImg]) thumbEls[currentImg].classList.remove('active');
    currentImg = ((idx % imgEls.length) + imgEls.length) % imgEls.length;
    const nextEl = imgEls[currentImg];
    if (nextEl) nextEl.classList.replace('hidden', 'active');
    if (thumbEls[currentImg]) thumbEls[currentImg].classList.add('active');
  }

  thumbEls.forEach(t => t.addEventListener('click', () =>
    showImg(t.dataset.idx != null ? t.dataset.idx : t.dataset.index)));
  const galNext = document.getElementById('gal-next');
  const galPrev = document.getElementById('gal-prev');
  if (galNext) galNext.addEventListener('click', () => showImg(currentImg + 1));
  if (galPrev) galPrev.addEventListener('click', () => showImg(currentImg - 1));

  // Swipe
  let gx = 0;
  const mainImg = document.getElementById('main-img');
  if (mainImg) {
    mainImg.addEventListener('touchstart', e => { gx = e.touches[0].clientX; }, { passive: true });
    mainImg.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - gx;
      if (Math.abs(dx) > 40) showImg(dx < 0 ? currentImg + 1 : currentImg - 1);
    });
  }
})();

// ── Product Card Swatches (homepage / collection page)
(function() {
  function initSwatches() {
    document.querySelectorAll('.pswatch').forEach(function(btn) {
      if (btn.dataset.swatchInit) return;
      btn.dataset.swatchInit = '1';
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var productId   = btn.dataset.productId;
        var variantId   = btn.dataset.variantId;
        var color       = (btn.dataset.color || '').toLowerCase();
        var url         = btn.dataset.url;
        var wrap        = btn.closest('.pc-wrap');
        var link        = wrap ? wrap.querySelector('.pc') : null;
        var mainImg     = wrap ? wrap.querySelector('.img-main') : null;
        var hoverImg    = wrap ? wrap.querySelector('.img-hover') : null;
        var swatchGroup = wrap ? wrap.querySelectorAll('.pswatch') : [];

        swatchGroup.forEach(function(s) { s.classList.remove('active'); });
        btn.classList.add('active');

        if (link && url) link.href = url;

        if (!link) return;
        var allImgs = link.querySelectorAll('.pi img');
        var matched = [];
        allImgs.forEach(function(img) {
          if ((img.alt || '').toLowerCase().indexOf(color) !== -1) matched.push(img);
        });

        // Use variant image src directly from data attribute if available
        var variantSrc = btn.dataset.imgSrc;
        var hoverSrc   = btn.dataset.hoverSrc;
        if (variantSrc && mainImg) {
          mainImg.src = variantSrc;
          mainImg.removeAttribute('srcset');
          if (hoverImg) {
            if (hoverSrc) {
              hoverImg.src = hoverSrc;
              hoverImg.style.display = '';
            } else {
              hoverImg.removeAttribute('src');
              hoverImg.style.display = 'none';
            }
            hoverImg.removeAttribute('srcset');
          }
        } else if (matched.length > 0 && mainImg) {
          mainImg.src = matched[0].src;
          mainImg.removeAttribute('srcset');
          if (hoverImg) {
            if (matched[1]) {
              hoverImg.src = matched[1].src;
              hoverImg.style.display = '';
            } else {
              hoverImg.removeAttribute('src');
              hoverImg.style.display = 'none';
            }
            hoverImg.removeAttribute('srcset');
          }
        }

        // Update extra slides to match selected colour
        var swatchesDiv = wrap ? wrap.querySelector('.pswatches') : null;
        if (swatchesDiv) {
          try {
            var colorImages = JSON.parse(swatchesDiv.dataset.colorImages || '{}');
            var colorImgList = colorImages[color] || [];
            if (colorImgList.length > 0) {
              var extraSlides = link.querySelectorAll('.pc-extra-slide');
              extraSlides.forEach(function(slide, i) {
                var extraIdx = i + 2;
                if (colorImgList[extraIdx]) slide.src = colorImgList[extraIdx];
              });
            }
          } catch(e) {}
        }

        // Reset card slider back to main image (slide 0) after colour change
        if (link) {
          var piEl = link.querySelector('.pi');
          if (piEl && !piEl.querySelector('.pc-track')) {
            /* legacy cross-fade card — keep the old reset */
            piEl.querySelectorAll('.img-main, .img-hover, .pc-extra-slide').forEach(function(el) {
              el.style.transition = 'opacity 0.22s ease';
              el.style.opacity = el.classList.contains('img-main') ? '1' : '0';
              el.style.zIndex  = el.classList.contains('img-main') ? '2' : '1';
              el.style.transform = 'none';
            });
          }
          if (window.ivynCardReset) window.ivynCardReset(link);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initSwatches);
  if (document.readyState !== 'loading') initSwatches();
})();

// ── Accordion — independent toggle per item, event delegation
document.addEventListener('click', function(e) {
  var head = e.target.closest('.acc-head');
  if (!head) return;
  var item = head.closest('.acc-item');
  if (!item) return;
  item.classList.toggle('open');
  var icon = head.querySelector('.acc-icon');
  if (icon) icon.textContent = item.classList.contains('open') ? '×' : '+';
  head.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');
});

// ── Size chart modal
(function () {
  const overlay    = document.getElementById('size-chart-overlay');
  const openLink   = document.getElementById('size-chart-link');
  const closeBtn   = document.getElementById('sc-close');
  if (!overlay) return;
  if (openLink)  openLink.addEventListener('click', e => { e.preventDefault(); overlay.classList.add('open'); });
  if (closeBtn)  closeBtn.addEventListener('click', () => overlay.classList.remove('open'));
  overlay.addEventListener('click', e => { if (e.target === overlay) overlay.classList.remove('open'); });
})();

// ── Filter panel JS
(function(){
  const toggleBtn = document.getElementById('filter-toggle-btn');
  const closeBtn  = document.getElementById('filter-close-btn');
  const applyBtn  = document.getElementById('filter-apply-btn');
  const panel     = document.getElementById('filter-panel');

  function openPanel() {
    if (!panel) return;
    panel.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closePanel() {
    if (!panel) return;
    panel.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (toggleBtn) toggleBtn.addEventListener('click', openPanel);
  if (closeBtn)  closeBtn.addEventListener('click', closePanel);
  if (applyBtn)  applyBtn.addEventListener('click', closePanel);

  if (panel) {
    panel.addEventListener('click', function(e) {
      if (e.target === panel) closePanel();
    });
  }

  document.querySelectorAll('.filter-group-head[data-fg]').forEach(btn => {
    btn.addEventListener('click', function() {
      const targetId = this.dataset.fg;
      const body     = document.getElementById(targetId);
      if (!body) return;
      const isOpen = body.style.display !== 'none';
      body.style.display = isOpen ? 'none' : 'block';
      this.classList.toggle('active', !isOpen);
      const arrow = this.querySelector('.fg-arrow');
      if (arrow) arrow.textContent = isOpen ? '+' : '−';
    });
  });
})();

/* ══ Product card image slider — track-based, finger-tracking ══ */
(function() {
  /* State lives per rendered .pc-wrap element, not per product id — the same
     product can legitimately appear twice on a page (grid + related rail). */
  var store = window.WeakMap ? new WeakMap() : null;
  var fallback = [];   /* [el, state] pairs for browsers with no WeakMap */

  function get(el) {
    if (store) return store.get(el);
    for (var i = 0; i < fallback.length; i++) if (fallback[i][0] === el) return fallback[i][1];
    return undefined;
  }
  function set(el, v) {
    if (store) { store.set(el, v); return; }
    fallback.push([el, v]);
  }

  var SNAP_RATIO = 0.15;   /* drag past 15% of card width to advance */
  var FLICK_VEL  = 0.35;   /* px/ms — a fast flick advances regardless of distance */

  function trackImgs(track) {
    return Array.prototype.slice.call(track.querySelectorAll('img'));
  }

  /* Promote a single lazy image to eager. Never called during init — only once
     the shopper has actually shown intent, so a 20-card grid still ships 20
     images on first paint rather than 40+. */
  function warmOne(s, i) {
    var img = s.imgs[i];
    if (img && img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
  }
  function warmNeighbours(s) {
    warmOne(s, s.cur + 1);
    warmOne(s, s.cur - 1);
  }

  function paintDots(s) {
    if (!s.dots) return;
    for (var i = 0; i < s.dots.length; i++) {
      s.dots[i].classList.toggle('active', i === s.cur);
    }
  }

  function settle(s) {
    s.track.style.transform = 'translate3d(' + (-s.cur * 100) + '%,0,0)';
    paintDots(s);
  }

  function slideTo(s, idx) {
    if (!s || s.imgs.length <= 1) return;
    /* clamped, not wrapped — running off the end of a 2-image card and
       landing back on image 1 reads as a glitch, not a loop */
    if (idx < 0) idx = 0;
    if (idx > s.imgs.length - 1) idx = s.imgs.length - 1;
    s.cur = idx;
    s.track.classList.add('user-moved');
    s.track.classList.remove('is-dragging');
    settle(s);
    warmNeighbours(s);   /* genuine interaction — safe to prefetch ahead */
  }

  window.ivynCardNav = function(btn, dir) {
    var wrap = btn.closest('.pc-wrap');
    if (!wrap) return;
    var s = get(wrap);
    if (!s) { initCard(wrap); s = get(wrap); }
    if (!s) return;
    slideTo(s, s.cur + dir);
  };

  function initCard(wrap) {
    if (get(wrap)) return;
    var pi = wrap.querySelector('.pi');
    if (!pi) return;
    var track = pi.querySelector('.pc-track');
    if (!track) return;                     /* card not upgraded — leave it alone */

    var imgs = trackImgs(track);
    var s = { cur: 0, imgs: imgs, track: track, pi: pi, dots: null, warmed: false };
    set(wrap, s);
    if (imgs.length <= 1) return;

    pi.classList.add('has-card-swipes');

    /* dots are built to match the real slide count */
    var dotWrap = pi.querySelector('.pc-swipe-dots');
    if (!dotWrap) {
      dotWrap = document.createElement('span');
      dotWrap.className = 'pc-swipe-dots';
      dotWrap.setAttribute('aria-hidden', 'true');
      pi.appendChild(dotWrap);
    }
    dotWrap.innerHTML = '';
    for (var d = 0; d < imgs.length; d++) dotWrap.appendChild(document.createElement('i'));
    s.dots = dotWrap.querySelectorAll('i');
    paintDots(s);

    var startX = 0, startY = 0, startT = 0, axis = null, w = 0, dx = 0;

    /* desktop hover reveals image 2 via CSS — warm it on intent, once */
    pi.addEventListener('pointerenter', function(e) {
      if (e.pointerType === 'touch' || s.warmed) return;
      s.warmed = true;
      warmOne(s, 1);
    }, { passive: true });

    pi.addEventListener('touchstart', function(e) {
      if (s.imgs.length <= 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      startT = Date.now();
      axis = null; dx = 0;
      w = pi.offsetWidth || 1;
      track.classList.add('is-dragging', 'user-moved');
      if (!s.warmed) { s.warmed = true; warmNeighbours(s); }
    }, { passive: true });

    pi.addEventListener('touchmove', function(e) {
      if (s.imgs.length <= 1) return;
      var mx = e.touches[0].clientX - startX;
      var my = e.touches[0].clientY - startY;

      if (axis === null) {
        if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
        axis = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
        if (axis === 'x') document.body.classList.add('ivyn-swipe-lock');
      }
      if (axis !== 'x') return;

      e.preventDefault();
      dx = mx;
      /* resist at the ends instead of stopping dead */
      if ((s.cur === 0 && dx > 0) || (s.cur === s.imgs.length - 1 && dx < 0)) dx *= 0.32;
      track.style.transform =
        'translate3d(' + (((-s.cur * w) + dx) / w * 100) + '%,0,0)';
    }, { passive: false });

    function release(moved) {
      document.body.classList.remove('ivyn-swipe-lock');
      track.classList.remove('is-dragging');
      if (axis !== 'x') { settle(s); return; }
      var vel = Math.abs(moved) / Math.max(1, Date.now() - startT);
      var far   = Math.abs(moved) > w * SNAP_RATIO;
      var flick = vel > FLICK_VEL && Math.abs(moved) > 24;
      if (far || flick) slideTo(s, s.cur + (moved < 0 ? 1 : -1));
      else settle(s);
    }

    pi.addEventListener('touchend', function(e) {
      if (s.imgs.length <= 1) return;
      release(e.changedTouches[0].clientX - startX);
    }, { passive: true });

    pi.addEventListener('touchcancel', function() {
      document.body.classList.remove('ivyn-swipe-lock');
      track.classList.remove('is-dragging');
      settle(s);
    }, { passive: true });

    /* a real swipe must not fire the card's link */
    pi.addEventListener('click', function(e) {
      if (axis === 'x' && Math.abs(dx) > 8) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  /* called by the colour swatches after they repoint the images */
  window.ivynCardReset = function(link) {
    var wrap = link ? link.closest('.pc-wrap') : null;
    if (!wrap) return;
    var pi = wrap.querySelector('.pi');
    if (!pi) return;
    var track = pi.querySelector('.pc-track');
    if (!track) return;
    var s = get(wrap);
    if (!s) { initCard(wrap); s = get(wrap); if (!s) return; }
    s.imgs = trackImgs(track);
    s.cur = 0;
    s.warmed = false;
    track.classList.add('is-dragging');
    track.classList.remove('user-moved');
    track.style.transform = 'translate3d(0,0,0)';
    requestAnimationFrame(function() { track.classList.remove('is-dragging'); });
    var dotWrap = pi.querySelector('.pc-swipe-dots');
    if (dotWrap) {
      dotWrap.innerHTML = '';
      for (var d = 0; d < s.imgs.length; d++) dotWrap.appendChild(document.createElement('i'));
      s.dots = dotWrap.querySelectorAll('i');
    }
    paintDots(s);
  };

  function initAll() { document.querySelectorAll('.pc-wrap').forEach(initCard); }
  document.addEventListener('DOMContentLoaded', initAll);
  if (document.readyState !== 'loading') initAll();

  /* cards injected by filters or pagination */
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function() { pending = false; initAll(); });
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();

/* ── Stop shimmer once images load ── */
(function() {
  function initShimmer() {
    document.querySelectorAll('.pi').forEach(function(pi) {
      if (pi.dataset.shimmerInit) return;
      pi.dataset.shimmerInit = '1';
      var img = pi.querySelector('.img-main');
      if (!img) return;
      if (img.complete && img.naturalWidth > 0) {
        pi.classList.add('img-loaded');
      } else {
        img.addEventListener('load', function() { pi.classList.add('img-loaded'); });
        img.addEventListener('error', function() { pi.classList.add('img-loaded'); });
      }
    });
  }
  document.addEventListener('DOMContentLoaded', initShimmer);
  if (document.readyState !== 'loading') initShimmer();
})();
